<template>
  <div
    v-if="show"
    class="nudging"
    :class="{mobile: mobile, 'retention': retention}"
  >
    <p>{{ t(`${retention ? 'nudging_message_retention' : 'nudging_message'}`) }}</p>
    <Icon
      name="xmark"
      class="button close-icon"
      :width="14"
      :height="14"
      art="regular"
      @click="nudgeClick(false)"
    />
    <ChatButton
      class="sanitas-button confirm"
      :types="['primary']"
      @click="nudgeClick(true)"
    >{{ t('nudging_buttons_yes') }}</ChatButton>
    <div class="nudging-arrow"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { useI36n } from '@jota-one/i36n/src/index.vue2'
import ChatButton from './ChatButton'
import Icon from './Icon'
import { trigger, triggerType } from '@/helpers/Tracker'
import { idle } from '../helpers/inactivityTracker'

export default {
  name: 'nudging',
  components: {
    ChatButton,
    Icon
  },
  props: {
    show: Boolean,
    mobile: Boolean,
    retention: Boolean
  },

  setup () {
    const { $label: t } = useI36n()

    return { t }
  },

  methods: {
    ...mapActions('nudging', [
      'closeNudgeConv',
      'openChat'
    ]),
    nudgeClick (nudge) {
      if (nudge) {
        trigger(triggerType.ACTION, 'ChatNudgingAccepted')
        this.openChat()
      } else {
        trigger(triggerType.ACTION, 'ChatNudgingRefused')
        this.closeNudgeConv()
        idle.stop()
        sessionStorage.isNudgingDisabled = true
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.nudging {
  z-index: 999;
  position: fixed;
  width: 164px;
  min-height: 97px;
  right: 60px;
  bottom: 152px;
  background-color: #004435;
  padding: 10px 15px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  &.retention {
    z-index: 1001;
  }
  .sanitas-button {
    font-size: 12px;
    font-weight: normal;
    width: 100%;
    font-family: "Open Sans", sans-serif;
  }
  .sanitas-button.confirm {
    text-transform: uppercase;
  }
  .sanitas-button.confirm:hover {
    background-color: #00765a;
  }
  .close-icon {
    position: absolute;
    top: 5px;
    right: 5px;
  }
  &.mobile {
    right: 40px;
    bottom: 169px;
  }
  p {
    color: white;
    margin-bottom: 10px;
    overflow-wrap: break-word;
    font-weight: bold;
  }
  .nudging-arrow {
    display: inline-block;
    position: absolute;
    transform: rotate(135deg);
    width: 15px;
    height: 20px;
    right: 22px;
    bottom: -8px;
    background-color: #004435;
  }
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .sanitas-button {
      box-shadow: 0px 0px 0px 0px;
    }
  }
}
</style>
